import * as React from "react"

function SvgSocialVideoYoutube(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 30 22"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
      >
        <path d="M29.375 5.674a4.297 4.297 0 00-4.296-4.299H4.92A4.297 4.297 0 00.625 5.674v11.401a4.297 4.297 0 004.295 4.3h20.158a4.297 4.297 0 004.297-4.297V5.674z" />
        <path d="M11.875 16.299V5.474l8.461 5.414z" />
      </g>
    </svg>
  )
}

export default SvgSocialVideoYoutube
